import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useValidEmail, useValidPhoneNumber } from "../hooks/useAuthHooks";
import { AuthContext } from "../context/authContext";
import cs from "classnames";
import { useLoading } from "../libs/loadingContext";
import PhoneNumber from "../components/auth/phoneNumber";
import Email from "../components/auth/email";
import AlertSignInError from "../components/alertSignInError";
import { useTranslation } from "react-i18next";

export default function RequestCode() {
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [isPhoneActive, setIsPhoneActive] = useState(false);
  const { email, setEmail, emailIsValid } = useValidEmail("");
  const {
    phoneNumber,
    setPhoneNumber,
    countryCode,
    setCountryCode,
    phoneNumberIsValid,
  } = useValidPhoneNumber("");
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { setLoading } = useLoading();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const isValidEmail = !emailIsValid || email.length === 0;

  const isValidPhoneNumber = !phoneNumberIsValid || phoneNumber.length === 0;

  useEffect(() => {
    if (phoneNumber) {
      setUsername(countryCode.dial_code + phoneNumber);
    }
  }, [phoneNumber, countryCode.dial_code, setUsername]);

  useEffect(() => {
    setUsername(email);
  }, [email, setEmail]);

  useEffect(() => {
    setUsername("");
    setEmail("");
    setPhoneNumber("");
  }, [isPhoneActive, setEmail, setPhoneNumber]);

  const sendCodeClicked = async () => {
    try {
      setLoading(true);
      localStorage.setItem("username", username);
      await authContext.sendCode(username);
      navigate("/forgot-password");
    } catch (err) {
      if (
        err.message === "Attempt limit exceeded, please try after some time."
      ) {
        setError(t("requestCode.attemptLimitExceeded"));
      } else {
        setError(t("requestCode.error"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="content-page">
        {error && <AlertSignInError message={error} />}
        <h3 className="process-title forget-password">
          {t("requestCode.forgotPassword")}
        </h3>
        <div className="form-group">
          <label>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setIsPhoneActive(false);
              }}
              className={cs("label-phone-number", {
                ["label-active"]: !isPhoneActive,
              })}
            >
              {t("requestCode.email")}
            </a>{" "}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setIsPhoneActive(true);
              }}
              className={cs("label-phone-number", {
                ["label-active"]: isPhoneActive,
              })}
            >
              / {t("requestCode.phoneNumber")}
            </a>
          </label>
          {!isPhoneActive ? (
            <Email
              emailIsValid={emailIsValid}
              setEmail={setEmail}
              email={email}
            />
          ) : (
            <div className="phoneNumberDropdown">
              <PhoneNumber
                phoneNumberIsValid={phoneNumberIsValid}
                setPhoneNumber={setPhoneNumber}
                phoneNumber={phoneNumber}
                countryCode={countryCode}
                setCountryCode={setCountryCode}
                isSelectable={true}
              />
            </div>
          )}
        </div>
        <div className="forgot-password-info">
          {t("requestCode.forgotPasswordInfo")}
        </div>
        <div className="forgot-password-request-btn">
          {isValidEmail && isValidPhoneNumber ? (
            <button className="btn btn-default btn-default-disabled">
              {t("requestCode.sentCode")}
            </button>
          ) : (
            <button
              className="btn btn-default"
              onClick={() => sendCodeClicked()}
            >
              {t("requestCode.sentCode")}
            </button>
          )}
        </div>
      </div>
    </>
  );
}
